
import "../Foundation/stylable/typography.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_178_0_Caption";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_178_0_Caption__root","text-medium-bold":"wds_1_178_0_StylableTypography__text-medium-bold","text-tiny-bold":"wds_1_178_0_StylableTypography__text-tiny-bold","c1":"wds_1_178_0_Caption__c1","c2":"wds_1_178_0_Caption__c2"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




